export function ToolButton({ image, disabled, onClick }: { image: "lock" | "unlock" | "add" | "new" | "edit" | "delete"; disabled?: boolean; onClick: () => void }) {
  const title = image === "add" ? "" : "Tilpasning på/av";

  return (
    <button className="h-8 w-8" title={title} disabled={disabled} onClick={onClick}>
      <img className="mx-auto" src={`/assets/images/hw/${image}.svg`} alt="" />
    </button>
  );
}
